import api from '@shared/api';

import {AuditStatisticsDto, AuditStatisticsRequestParams} from './types';

const DDA_PATH = 'dda/api/v1';

export const fetchStatistics = async ({
    year,
    month,
    violationTypeIds,
}: AuditStatisticsRequestParams) =>
    (
        await api.get<AuditStatisticsDto>(`${DDA_PATH}/statistic/${year}`, {
            params: {
                ...(month && {taxPeriodMonth: month}),
                ...(violationTypeIds?.length && {violationTypeIds}),
            },
            paramsSerializer: {indexes: null},
        })
    ).data;
